import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {ContactListItems} from "./ContactListItems";

export default function ContactList(props) {
    const [data, setData] = useState({contacts: [], loading: true,});

    const navigate = useNavigate()

    const fetchData = async () => {
        var url = API_URL + '/api/private/tanker/v1/contacts'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                setData({contacts: data, loading: false});
            });
    }

    useEffect(() => {
        document.title = 'Credit note detail'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    return (
        <div>
            <ContactListItems contacts={data.contacts}/>
        </div>
    )
}


